import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageKeys } from 'src/app/configs/storage-keys-config';

@Injectable()
export class CultureInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const newReq = req.clone({
      params: (req.params ? req.params : new HttpParams()).set(
        'culture',
        localStorage.getItem(StorageKeys.lang)
      ),
    });
    return next.handle(newReq);
  }
}

export const HttpCultureInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CultureInterceptor, multi: true },
];
